import React, { useState, useEffect } from "react";
import { LayoutDashboard, UserCircle, CalendarDays, Timer, Menu, LogOut } from "lucide-react";
import { useSesion } from "../../context/System/SesionContext";

const HcorzNavbar = ({ title, onMenuClick }) => {
  const { usuarioData, handleClickCerrarSesion } = useSesion();
  const [currentTime, setCurrentTime] = useState(() =>
    new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
  );

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(
        new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
      );
    }, 30000);
    return () => clearInterval(timer);
  }, []);

  const userName =
    usuarioData?.username ||
    usuarioData?.Nombre ||
    usuarioData?.Usuario ||
    "Administrador";

  return (
    <header className="h-[56px] bg-white border-b border-slate-200 flex items-center justify-between px-3 md:px-4 shrink-0 z-10 shadow-sm">
      <div className="flex items-center gap-2">
        {/* Mobile-only Hamburger Button */}
        <button
          onClick={onMenuClick}
          className="md:hidden p-1.5 text-slate-600 hover:bg-slate-100 rounded-md transition-colors"
          title="Abrir menú móvil"
        >
          <Menu className="w-5 h-5" />
        </button>

        <div className="flex items-center">
          <span className="inline-flex items-center border border-[#0A6ED1]/20 bg-[#0A6ED1]/10 text-[#0A6ED1] px-2.5 py-1 rounded text-xs md:text-[0.82rem] font-bold">
            <LayoutDashboard className="w-[14px] h-[14px] mr-1.5 shrink-0" />
            <span className="truncate max-w-[160px] sm:max-w-xs md:max-w-none">
              Módulo: {title || "Resumen"}
            </span>
          </span>
        </div>
      </div>

      <div className="flex items-center gap-2 sm:gap-3 text-[0.75rem] md:text-[0.8rem] text-slate-500 font-medium">
        <div className="flex items-center">
          <UserCircle className="w-3.5 h-3.5 text-[#0A6ED1] mr-1 shrink-0" />
          <span className="hidden sm:inline">Usuario:</span>
          <strong className="text-slate-900 ml-1">{userName}</strong>
        </div>
        <div className="hidden sm:block h-3.5 w-px bg-slate-200"></div>
        <div className="hidden sm:flex items-center">
          <CalendarDays className="w-3.5 h-3.5 text-[#0A6ED1] mr-1 shrink-0" />
          <span>Fecha:</span>
          <strong className="text-slate-900 ml-1">
            {new Date().toISOString().split("T")[0]}
          </strong>
        </div>
        <div className="hidden md:block h-3.5 w-px bg-slate-200"></div>
        <div className="flex items-center">
          <Timer className="w-3.5 h-3.5 text-[#0A6ED1] mr-1 shrink-0" />
          <span className="hidden sm:inline">Hora:</span>
          <strong className="text-slate-900 ml-1">{currentTime}</strong>
        </div>
        <div className="hidden sm:block h-3.5 w-px bg-slate-200"></div>
        <button
          onClick={handleClickCerrarSesion}
          className="text-slate-400 hover:text-red-600 transition-colors p-1.5 rounded hover:bg-red-50"
          title="Cerrar Sesión"
        >
          <LogOut className="w-4 h-4" />
        </button>
      </div>
    </header>
  );
};

export default HcorzNavbar;
